<template>
  <div class="hardware-main">
    <div class="hardware-box">
      <div class="hardware-title">{{ $t('hardfour.hardwareTitle') }}</div>
      <div class="hardware-li">{{ $t('hardfour.internalDimensions') }}</div>
      <div class="hardware-li">{{ $t('hardfour.externalDimensions') }}</div>
      <div class="hardware-li">{{ $t('hardfour.dimensionsCustomizable') }}</div>
      <div class="hardware-title">{{ $t('hardfour.electricalTitle') }}</div>
      <div class="hardware-li">{{ $t('hardfour.powerSource') }}</div>
      <div class="hardware-li">{{ $t('hardfour.powerConsumption') }}</div>
      <div class="hardware-li">{{ $t('hardfour.controlSystem') }}</div>
      <div class="hardware-li">{{ $t('hardfour.pcSpecification') }}</div>
      <div class="hardware-li">{{ $t('hardfour.antiCollisionSensor') }}</div>
      <div class="hardware-li">{{ $t('hardfour.alarmLight') }}</div>
      <div class="hardware-title">{{ $t('hardfour.rfidTitle') }}</div>
      <div class="hardware-li">{{ $t('hardfour.readerModel') }}</div>
      <div class="hardware-li">{{ $t('hardfour.antennaModel') }}</div>
      <div class="hardware-li">{{ $t('hardfour.detectionQuantity') }}</div>
      <div class="hardware-li">{{ $t('hardfour.shieldingMethod') }}</div>
      <div class="hardware-li">{{ $t('hardfour.shieldingPerformance') }}</div>
      <div class="hardware-li">{{ $t('hardfour.shieldingDoorsCustomizable') }}</div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
</style>